import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_offline-forms')({
  component: OfflineFormLayoutComponent,
})

function OfflineFormLayoutComponent() {
  return (
    <div className="container mx-auto max-w-3xl py-2 flex flex-col gap-6">
      <div className="flex items-center justify-between w-full max-w-xl mx-auto p-4">
        <h1 className="text-2xl font-semibold">Onboarding</h1>
      </div>
      <Outlet />
    </div>
  );
}
